import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";
const {
  saleBanList,
  getGameServerList,
  accountBanList,
  accountBan,
  accountUnBan,
  saleBan,
  saleUnBan,
  saleBanEdit,
} = httpApi.saleBan;

interface PageSize {
  page: number;
  size: number;
}
// 寄售封禁列表
interface SaleBanListParams extends PageSize {
  game_id: string;
  role_id: string;
}
export const apiSaleBanList = (json: SaleBanListParams): any =>
  http.httpPost({
    url: saleBanList,
    json,
  });
// 寄售封禁
interface SaleBanParams {
  game_id?: number;
  server_id?: number;
  role_id: string;
  ban_role: number;
  ban_coin: number;
  ban_equip: number;
  reason: string;
}
export const apiSaleBan = (json: SaleBanParams): any =>
  http.httpPost({
    url: saleBan,
    json,
  });
// 区服列表接口
interface GetGameServerListParams {
  game_id: string;
}
export const apiGetGameServerList = (json: GetGameServerListParams): any =>
  http.httpPost({
    url: getGameServerList,
    json,
  });
// 盒子号封禁列表
export const apiAccountBanList = (json: PageSize): any =>
  http.httpPost({
    url: accountBanList,
    json,
  });
// 盒子号封禁
interface AccountBanParams {
  uid: string;
  reason?: string;
}
export const apiAccountBan = (json: AccountBanParams): any =>
  http.httpPost({
    url: accountBan,
    json,
  });
// 盒子号解禁
interface AccountUnBanParams {
  id: string;
}
export const apiAccountUnBan = (json: AccountUnBanParams): any =>
  http.httpPost({
    url: accountUnBan,
    json,
  });
// 寄售解禁
export const apiSaleUnBan = (json: AccountUnBanParams): any =>
  http.httpPost({
    url: saleUnBan,
    json,
  });
// 修改类型
interface SaleBanEditParams {
  id: string;
  ban_role: number;
  ban_coin: number;
  ban_equip: number;
  reason: string;
}
export const apiSaleBanEdit = (json: SaleBanEditParams): any =>
  http.httpPost({
    url: saleBanEdit,
    json,
  });
